import { render } from "./ASMetodaAtelierului.vue?vue&type=template&id=7a70db23"
import script from "./ASMetodaAtelierului.vue?vue&type=script&lang=js"
export * from "./ASMetodaAtelierului.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__